'use memo'

import React from 'react'
import { useFormikContext } from 'formik'
import {
  formatDetailValue,
  type PlayerDetailsFieldDef,
  type PlayerDetailsFormValues,
} from '@sportninja/common/features/profile/player/playerDetails'
import ReadOnlyField from 'src/features/profile/player/setupModal/components/ReadOnlyField'

interface DetailReadFieldProps {
  def: PlayerDetailsFieldDef
}

/** A field's label and saved value, for a section that is not being edited. */
const DetailReadField: React.FC<DetailReadFieldProps> = ({ def }) => {
  const { values } = useFormikContext<PlayerDetailsFormValues>()
  return (
    <ReadOnlyField label={def.label} value={formatDetailValue(def, values)} />
  )
}

export default DetailReadField
